interface IValue {
    [key: string]: number | string | boolean;
}
const removeEmptyValues = (values: IValue): IValue => Object.keys(values).reduce((acc, key) => {
    if (values[key] === undefined) {
        return acc;
    }
    return {
        ...acc,
        [key]: values[key],
    };
}, {});
export default removeEmptyValues;
